<div id="fullscreen" class="btn-header transparent hidden-xs hidden-sm hidden-md cursor-pointer">
        <span> <a (click)="onToggle()" title="{{'common_all_header_icon_cart_full_screen' | i18n}}"><i
                                class="material-icons-outlined icon-14 primary-font">fit_screen</i></a> </span>
</div>